import { useEffect, useState } from 'react';

import { Modal } from '@components/modal/Modal';

import { useCommonContext } from '@hooks/commonContext';
import { IFolder, useBookmarks } from '@hooks/useBookmarks';
import useTranslation from '@hooks/useTranslation';
import { Box, Button, TextField, Typography } from '@mui/material';

export function EditBookmarkModal({
    folderUuid,
    handleClose,
}: {
    folderUuid: string;
    handleClose: () => void;
}) {
    const { setShowSnackbar } = useCommonContext();
    const { t } = useTranslation('bookmark');
    const { updateFolder, getFolder } = useBookmarks();
    const [folder, setFolder] = useState<IFolder | null>(null);
    const [name, setName] = useState('');
    const [error, setError] = useState<string | null>(null);
    async function submitUpdate() {
        if (!folder) return;

        try {
            await updateFolder(folder.uuid, {
                name: name,
                hadith_ids: folder.hadith_ids,
            });
            setShowSnackbar({
                message: t('folder_updated'),
                show: true,
                severity: 'success',
            });
            handleClose();
        } catch (error: any) {
            console.error(error);
            setError(error.message);
        }
    }

    useEffect(() => {
        if (folderUuid) {
            getFolder(folderUuid).then((folder) => {
                setFolder(folder);
                setName(folder.name);
            });
        }
    }, [folderUuid]);

    return (
        <Modal handleClose={handleClose} title={t('edit_folder')} maxWidth="xs">
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitUpdate();
                }}
                style={{ marginTop: '5px' }}
            >
                <TextField
                    label={t('folder_name')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                    autoFocus
                    error={!!error}
                    helperText={error}
                />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mt: 2,
                    }}
                >
                    <Button
                        type="submit"
                        variant="contained"
                        color="secondary"
                        sx={{ p: '10px 20px' }}
                        disabled={!name.length}
                    >
                        {t('edit')}
                    </Button>
                </Box>
            </form>
        </Modal>
    );
}
